import { render, staticRenderFns } from "./NyranSurvivors.vue?vue&type=template&id=61ac242a&"
import script from "./NyranSurvivors.vue?vue&type=script&lang=js&"
export * from "./NyranSurvivors.vue?vue&type=script&lang=js&"
import style0 from "./NyranSurvivors.vue?vue&type=style&index=0&id=61ac242a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports